import { Controller } from "stimulus";

export default class HeaderController extends Controller {
  toggleExpanded() {
    this.element.classList.toggle("expanded");
  }
}
